export default {
  productSaleInfo: {
    labels: {
      barcode: 'BARKOD',
      stockCode: 'SATICI STOK KODU',
      salePrice: 'TRENDYOL SATIŞ FİYATI',
      vatRate: 'KDV',
      stockCount: 'STOK ADETİ',
      listPrice: 'PİYASA SATIŞ FİYATI',
    },
    placeholders: {
      barcode: 'Barkod',
      stockCode: 'Satıcı Stok Kodu',
      salePrice: 'Satış Fiyatı',
      vatRate: 'KDV Oranı',
      stockCount: 'Stok Adeti',
      listPrice: 'Piyasa Fiyatı',
    },
    addVariantBtn: 'YENİ VARYANT EKLE',
    existsMessage: 'Bu ürün, Ürün Listenizde bulunuyor.',
  },
};
